// MapTiler Streets Dark v2 style layers for globe projection
export const globeMapLayers = {
  version: 8,
  id: 'streets-v2-dark',
  name: 'Streets Dark',
  sources: {
    'maptiler-planet': {
      url: 'https://api.maptiler.com/tiles/v3/tiles.json?key=1dLDz8EgQO3YOIj3WxGi',
      type: 'vector'
    }
  },
  layers: [
    // Background layer
    {
      "id": "Background",
      "type": "background",
      "paint": {
        "background-color": ["interpolate", ["exponential", 1], ["zoom"], 6, "hsl(216, 37%, 24%)", 14, "hsl(216, 38%, 23%)"]
      }
    },
    
    // Water bodies
    {
      "id": "Water",
      "type": "fill",
      "source": "maptiler-planet",
      "source-layer": "water",
      "layout": { "visibility": "visible" },
      "paint": {
        "fill-antialias": true,
        "fill-color": "hsl(217, 36%, 14%)",
        "fill-opacity": 1
      }
    },
    
    // Water labels
    {
      "id": "Water-labels",
      "type": "symbol",
      "source": "maptiler-planet",
      "source-layer": "water",
      "minzoom": 8,
      "layout": {
        "text-field": "{name:en}",
        "text-font": ["Roboto Medium", "Noto Sans Regular"],
        "text-size": 12,
        "text-transform": "uppercase",
        "text-letter-spacing": 0.1
      },
      "paint": {
        "text-color": "hsl(217, 36%, 40%)",
        "text-halo-color": "hsl(216, 37%, 24%)",
        "text-halo-width": 1
      }
    },
    
    // Landcover layers
    {
      "id": "Wood",
      "type": "fill",
      "source": "maptiler-planet",
      "source-layer": "landcover",
      "minzoom": 8,
      "layout": { "visibility": "visible" },
      "paint": {
        "fill-antialias": true,
        "fill-color": "hsl(203, 47%, 22%)",
        "fill-opacity": {"stops": [[7, 0.7], [12, 1]]}
      },
      "filter": ["==", "class", "wood"]
    },
    
    {
      "id": "Grass",
      "type": "fill",
      "source": "maptiler-planet",
      "source-layer": "landcover",
      "minzoom": 8,
      "layout": { "visibility": "visible" },
      "paint": {
        "fill-antialias": true,
        "fill-color": "hsl(191, 33%, 17%)",
        "fill-opacity": {"stops": [[7, 0.7], [12, 1]]}
      },
      "filter": ["==", "class", "grass"]
    },
    
    {
      "id": "Sand",
      "type": "fill",
      "source": "maptiler-planet",
      "source-layer": "landcover",
      "minzoom": 8,
      "layout": { "visibility": "visible" },
      "paint": {
        "fill-antialias": false,
        "fill-color": "hsl(195, 64%, 22%)",
        "fill-opacity": 0.85
      },
      "filter": ["==", "class", "sand"]
    },
    
    {
      "id": "Glacier",
      "type": "fill",
      "source": "maptiler-planet",
      "source-layer": "landcover",
      "minzoom": 8,
      "layout": { "visibility": "visible" },
      "paint": {
        "fill-antialias": true,
        "fill-color": "hsl(204, 66%, 25%)",
        "fill-opacity": {"stops": [[0, 1], [10, 0.7]]}
      },
      "filter": ["==", "class", "ice"]
    },
    
    // Landuse layers
    {
      "id": "Residential",
      "type": "fill",
      "source": "maptiler-planet",
      "source-layer": "landuse",
      "layout": { "visibility": "visible" },
      "paint": {
        "fill-color": {
          "base": 1,
          "stops": [[4, "hsl(217, 37%, 24%)"], [12, "hsl(215, 15%, 23%)"], [16, "hsl(215, 15%, 23%)"]]
        }
      },
      "filter": ["in", "class", "neighbourhood", "residential", "suburb"]
    },
    
    {
      "id": "Commercial",
      "type": "fill",
      "source": "maptiler-planet",
      "source-layer": "landuse",
      "layout": { "visibility": "visible" },
      "paint": {
        "fill-antialias": false,
        "fill-color": "hsl(215, 38%, 21%)"
      },
      "filter": ["==", "class", "commercial"]
    },
    
    {
      "id": "Industrial",
      "type": "fill",
      "source": "maptiler-planet",
      "source-layer": "landuse",
      "layout": { "visibility": "visible" },
      "paint": {
        "fill-antialias": false,
        "fill-color": "hsl(215, 38%, 21%)"
      },
      "filter": ["in", "class", "garages", "industrial"]
    },
    
    {
      "id": "Hospital",
      "type": "fill",
      "source": "maptiler-planet",
      "source-layer": "landuse",
      "minzoom": 9,
      "layout": { "visibility": "visible" },
      "paint": {
        "fill-antialias": true,
        "fill-color": "hsl(256, 17%, 22%)",
        "fill-opacity": {"stops": [[9, 0.25], [16, 1]]}
      },
      "filter": ["==", "class", "hospital"]
    },
    
    {
      "id": "School",
      "type": "fill",
      "source": "maptiler-planet",
      "source-layer": "landuse",
      "minzoom": 9,
      "layout": { "visibility": "visible" },
      "paint": {
        "fill-antialias": true,
        "fill-color": "hsl(210, 40%, 29%)",
        "fill-opacity": {"stops": [[9, 0.25], [16, 1]]}
      },
      "filter": ["in", "class", "college", "school", "university"]
    },
    
    {
      "id": "Stadium",
      "type": "fill",
      "source": "maptiler-planet",
      "source-layer": "landuse",
      "minzoom": 9,
      "layout": { "visibility": "visible" },
      "paint": {
        "fill-antialias": true,
        "fill-color": "hsl(183, 22%, 20%)",
        "fill-opacity": {"stops": [[9, 0.25], [16, 1]]}
      },
      "filter": ["in", "class", "pitch", "stadium", "playground"]
    },
    
    // Transportation layers
    {
      "id": "Highway",
      "type": "line",
      "source": "maptiler-planet",
      "source-layer": "transportation",
      "minzoom": 4,
      "layout": {
        "line-cap": "round",
        "line-join": "round",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "hsl(0, 0%, 85%)",
        "line-width": {
          "base": 1.2,
          "stops": [[4, 0.5], [6, 1], [8, 2], [10, 4], [12, 8], [14, 12], [16, 16]]
        }
      },
      "filter": ["==", "class", "highway"]
    },
    
    {
      "id": "Major-road",
      "type": "line",
      "source": "maptiler-planet",
      "source-layer": "transportation",
      "minzoom": 6,
      "layout": {
        "line-cap": "round",
        "line-join": "round",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "hsl(0, 0%, 75%)",
        "line-width": {
          "base": 1.2,
          "stops": [[6, 0.5], [8, 1], [10, 2], [12, 4], [14, 8], [16, 12]]
        }
      },
      "filter": ["==", "class", "primary"]
    },
    
    {
      "id": "Minor-road",
      "type": "line",
      "source": "maptiler-planet",
      "source-layer": "transportation",
      "minzoom": 8,
      "layout": {
        "line-cap": "round",
        "line-join": "round",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "hsl(0, 0%, 65%)",
        "line-width": {
          "base": 1.2,
          "stops": [[8, 0.5], [10, 1], [12, 2], [14, 4], [16, 8]]
        }
      },
      "filter": ["in", "class", "secondary", "tertiary"]
    },
    
    {
      "id": "Railway",
      "type": "line",
      "source": "maptiler-planet",
      "source-layer": "transportation",
      "minzoom": 8,
      "layout": {
        "line-cap": "round",
        "line-join": "round",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "hsl(0, 0%, 60%)",
        "line-width": {
          "base": 1.2,
          "stops": [[8, 0.5], [10, 1], [12, 2], [14, 4], [16, 6]]
        }
      },
      "filter": ["==", "class", "rail"]
    },
    
    // Building layers
    {
      "id": "Building",
      "type": "fill",
      "source": "maptiler-planet",
      "source-layer": "building",
      "minzoom": 12,
      "layout": { "visibility": "visible" },
      "paint": {
        "fill-color": "hsl(215, 20%, 25%)",
        "fill-opacity": 0.8
      }
    },
    
    {
      "id": "Building-3d",
      "type": "fill-extrusion",
      "source": "maptiler-planet",
      "source-layer": "building",
      "minzoom": 14,
      "layout": { "visibility": "visible" },
      "paint": {
        "fill-extrusion-color": "hsl(215, 20%, 25%)",
        "fill-extrusion-height": {
          "type": "identity",
          "property": "height"
        },
        "fill-extrusion-base": {
          "type": "identity",
          "property": "min_height"
        },
        "fill-extrusion-opacity": 0.8
      }
    },
    
    // Administrative boundaries
    {
      "id": "Country-border",
      "type": "line",
      "source": "maptiler-planet",
      "source-layer": "boundary",
      "minzoom": 2,
      "layout": {
        "line-cap": "round",
        "line-join": "round",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "hsl(0, 0%, 50%)",
        "line-width": {
          "base": 1,
          "stops": [[2, 0.5], [4, 1], [6, 2], [8, 3], [10, 4]]
        },
        "line-opacity": 0.6
      },
      "filter": ["==", "class", "country"]
    },
    
    {
      "id": "State-border",
      "type": "line",
      "source": "maptiler-planet",
      "source-layer": "boundary",
      "minzoom": 4,
      "layout": {
        "line-cap": "round",
        "line-join": "round",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "hsl(0, 0%, 45%)",
        "line-width": {
          "base": 1,
          "stops": [[4, 0.5], [6, 1], [8, 1.5], [10, 2]]
        },
        "line-opacity": 0.5
      },
      "filter": ["==", "class", "state"]
    },
    
    // Place labels
    {
      "id": "City-labels",
      "type": "symbol",
      "source": "maptiler-planet",
      "source-layer": "place",
      "minzoom": 4,
      "maxzoom": 16,
      "layout": {
        "text-field": "{name:en}",
        "text-font": ["Roboto Medium", "Noto Sans Regular"],
        "text-size": {
          "base": 1,
          "stops": [[4, 12], [8, 16], [12, 20], [16, 24]]
        },
        "text-transform": "uppercase",
        "text-letter-spacing": 0.05,
        "text-max-width": 8
      },
      "paint": {
        "text-color": "hsl(0, 0%, 100%)",
        "text-halo-color": "hsl(0, 0%, 20%)",
        "text-halo-width": 1,
        "text-halo-blur": 0.5
      },
      "filter": ["==", "class", "city"]
    },
    
    {
      "id": "Town-labels",
      "type": "symbol",
      "source": "maptiler-planet",
      "source-layer": "place",
      "minzoom": 6,
      "maxzoom": 16,
      "layout": {
        "text-field": "{name:en}",
        "text-font": ["Roboto Medium", "Noto Sans Regular"],
        "text-size": {
          "base": 1,
          "stops": [[6, 10], [10, 14], [14, 18]]
        },
        "text-transform": "uppercase",
        "text-letter-spacing": 0.05,
        "text-max-width": 8
      },
      "paint": {
        "text-color": "hsl(0, 0%, 90%)",
        "text-halo-color": "hsl(0, 0%, 20%)",
        "text-halo-width": 1,
        "text-halo-blur": 0.5
      },
      "filter": ["==", "class", "town"]
    },
    
    {
      "id": "Country-labels",
      "type": "symbol",
      "source": "maptiler-planet",
      "source-layer": "place",
      "minzoom": 1,
      "maxzoom": 12,
      "layout": {
        "text-field": "{name:en}",
        "text-font": ["Roboto Medium", "Noto Sans Regular"],
        "text-size": {
          "base": 1,
          "stops": [[1, 10], [4, 14], [8, 18], [12, 22]]
        },
        "text-transform": "uppercase",
        "text-letter-spacing": 0.1,
        "text-max-width": 8
      },
      "paint": {
        "text-color": "hsl(0, 0%, 100%)",
        "text-halo-color": "hsl(0, 0%, 20%)",
        "text-halo-width": 1.5,
        "text-halo-blur": 1
      },
      "filter": ["==", "class", "country"]
    },
    
    // POI (Points of Interest) labels
    {
      "id": "POI-labels",
      "type": "symbol",
      "source": "maptiler-planet",
      "source-layer": "poi",
      "minzoom": 10,
      "layout": {
        "text-field": "{name:en}",
        "text-font": ["Roboto Regular", "Noto Sans Regular"],
        "text-size": 10,
        "text-max-width": 6
      },
      "paint": {
        "text-color": "hsl(0, 0%, 80%)",
        "text-halo-color": "hsl(0, 0%, 20%)",
        "text-halo-width": 0.5
      }
    }
  ],
  glyphs: 'https://api.maptiler.com/fonts/{fontstack}/{range}.pbf?key=1dLDz8EgQO3YOIj3WxGi',
  sprite: 'https://api.maptiler.com/maps/streets-v2-dark/sprite'
};
